module.exports = __webpack_public_path__ + "media/images/emblems/Herrliberg-blazon-66863b457c87c0ab0cc96801e7c1c186.svg";